module.exports = __webpack_public_path__ + "static/media/failure_audio.e20fe146.mp3";